import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/home/gfs-group-tradelines-for-sale-320w.webp")